module.exports = __webpack_public_path__ + "static/media/vmbug.19bdabea.svg";